const PREFIXED = {
  escalation: 'escalation_prefix',
  ai_check: 'ai_check_prefix',
  manual_key_required: 'manual_key_required_prefix',
  manual_action_required: 'manual_action_required_prefix',
  split_from: 'split_from_prefix',
};

export function tagLabel(tag, t) {
  if (!tag) return '';

  const directKey = `tags.${tag}`;
  const direct = t(directKey, { defaultValue: '' });
  if (direct) return direct;

  const colonIdx = tag.indexOf(':');
  if (colonIdx > 0) {
    const prefix = tag.slice(0, colonIdx);
    const suffix = tag.slice(colonIdx + 1);

    if (PREFIXED[prefix]) {
      const prefixLabel = t(`tags.${PREFIXED[prefix]}`);
      const suffixLabel = t(`intent.${suffix}`, { defaultValue: '' })
        || t(`tags.${suffix}`, { defaultValue: '' })
        || suffix.replace(/_/g, ' ');
      return `${prefixLabel}: ${suffixLabel}`;
    }
  }

  return tag.replace(/_/g, ' ');
}
